import { render, staticRenderFns } from "./InlineButton.vue?vue&type=template&id=16f2181c&scoped=true&"
import script from "./InlineButton.vue?vue&type=script&lang=js&"
export * from "./InlineButton.vue?vue&type=script&lang=js&"
import style0 from "./InlineButton.vue?vue&type=style&index=0&id=16f2181c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f2181c",
  null
  
)

export default component.exports